import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { Typography } from '@mui/material';
import { TooltipIcon } from 'common/components/TooltipIcon';

type CardContentTitleProps = {
    description?: string;
    title: string;
}

export function CardContentTitle({
    description,
    title
}: Readonly<CardContentTitleProps>) {
    return (
        <Typography
            align='left'
            variant='body1'
            color='text.secondary'
            sx={{
                alignItems: 'center',
                display: 'flex',
                fontSize: '12px',
            }}
        >
            {title}
            {description && (
                <TooltipIcon
                    IconComponent={InfoOutlined}
                    tooltipTitle={description}
                    iconColor='action'
                    iconInlineStyles={{ marginLeft: '5px' }}
                    iconSize='inherit'
                />
            )}
        </Typography>
    );
}
